import React from 'react';
import PropTypes from 'prop-types';
import { SvgIcon } from 'material-ui';

const UncheckedIcon = props => (
  <SvgIcon {...props} viewBox='0 0 24 24' style={{ height: 24, width: 24 }}>
    <g id='Design' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g
        id='check'
        transform='translate(1.000000, 1.000000)'
        stroke={props.color || '#2974FF'}
        strokeWidth='2'
      >
        <circle id='Oval-3-Copy-2' cx='11' cy='11' r='11' />
      </g>
    </g>
  </SvgIcon>
);

UncheckedIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default UncheckedIcon;



// WEBPACK FOOTER //
// ./src/icons/UncheckedIcon.js